import { ComponentType } from 'react'
import ReactCounterInput from 'react-counter-input'

export const CounterInput: ComponentType<{
  value?: number | string
  max?: number
  min?: number
  onChange?: (value: number) => void
}> = ({ value, max, min, onChange }) => {
  return (
    <ReactCounterInput
      count={Number(value)}
      max={max}
      min={min}
      onCountChange={onChange}
      inputStyle={{
        outline: 'none',
        fontSize: 15,
        color: '#505862',
        lineHeight: 1,
      }}
      btnStyle={{
        height: 25,
        width: 25,
        borderRadius: 25,
        border: '1px solid #C5CCD5',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#A2AAB4',
      }}
    />
  )
}
